import { faker } from '@faker-js/faker'

import { TargetLanguage } from '../../contracts/service-offer'
import { AdminTreatmentRequest } from '../../contracts/treatment'
import { asBuilder } from '../asBuilder'

export const getAdminTreatmentRequest = asBuilder((): AdminTreatmentRequest => {
  return {
    filter: {
      targetLanguage: faker.helpers.enumValue(TargetLanguage),
      name: faker.lorem.word(),
    },
    pagination: {
      pageSize: faker.number.int(),
      pageIndex: faker.number.int(),
    },
  }
})
